import { useStore } from '../store';
import { Tabs } from './Tabs';
import { BodyEditor } from './BodyEditor';
import { HeadersPanel } from './HeadersPanel';
import { CapturesPanel } from './CapturesPanel';
import { UrlBar } from './UrlBar';

export function Main() {
  const tab = useStore((s) => s.tab);
  return (
    <main className="main">
      <Tabs />
      <UrlBar />
      {tab === 'body' && <BodyEditor />}
      {tab === 'headers' && <HeadersPanel />}
      {tab === 'captures' && (
        <div className="pane captures-pane">
          <CapturesPanel />
        </div>
      )}
    </main>
  );
}
